module.exports = __webpack_public_path__ + "img/pen-paintbrush.4937bd32.svg";